const actions = {
    COMPANY_CREATE_REQUEST: 'COMPANY_CREATE_REQUEST',
    COMPANY_CREATE_SUCCESS: 'COMPANY_CREATE_SUCCESS',
    COMPANY_CREATE_ERROR: 'COMPANY_CREATE_ERROR',
    READ_COMPANY_REQUEST: 'READ_COMPANY_REQUEST',
    READ_COMPANY_SUCCESS: 'READ_COMPANY_SUCCESS',
    READ_COMPANY_ERROR: 'READ_COMPANY_ERROR',
    READ_MY_INVOIS_READY_REQUEST: 'READ_MY_INVOIS_READY_REQUEST',
    READ_MY_INVOIS_READY_SUCCESS: 'READ_MY_INVOIS_READY_SUCCESS',
    READ_MY_INVOIS_READY_ERROR: 'READ_MY_INVOIS_READY_ERROR',
    RESET_PREV_IS_MY_INVOIS_READY: 'RESET_PREV_IS_MY_INVOIS_READY',
    SET_PREV_AND_CURRENT_IS_MY_INVOIS_READY: 'SET_PREV_AND_CURRENT_IS_MY_INVOIS_READY',
    READ_COMPANY_LIST_REQUEST: 'READ_COMPANY_LIST_REQUEST',
    READ_COMPANY_LIST_SUCCESS: 'READ_COMPANY_LIST_SUCCESS',
    READ_COMPANY_LIST_ERROR: 'READ_COMPANY_LIST_ERROR',
    UPDATE_COMPANY_REQUEST: 'UPDATE_COMPANY_REQUEST',
    UPDATE_COMPANY_SUCCESS: 'UPDATE_COMPANY_SUCCESS',
    UPDATE_COMPANY_ERROR: 'UPDATE_COMPANY_ERROR',
    PATCH_MSIC_CODE_REQUEST: 'PATCH_MSIC_CODE_REQUEST',
    PATCH_MSIC_CODE_SUCCESS: 'PATCH_MSIC_CODE_SUCCESS',
    PATCH_MSIC_CODE_ERROR: 'PATCH_MSIC_CODE_ERROR',
    CHANGE_COMPANY: 'CHANGE_COMPANY',
    CHANGE_COPY_BILLING_ADDRESS: 'CHANGE_COPY_BILLING_ADDRESS',
    COMPANY_RESET_REQUEST: 'COMPANY_RESET_REQUEST',
    COMPANY_RESET_SUCCESS: 'COMPANY_RESET_SUCCESS',
    COMPANY_RESET_ERROR: 'COMPANY_RESET_ERROR',
    SET_ALL_COMPANY_ADDRESSES: 'UPDATE_COMPANY_ADDRESS',
    ADD_COMPANY_ADDRESS: 'ADD_COMPANY_ADDRESS',
    DELETE_COMPANY_ADDRESS: 'DELETE_COMPANY_ADDRESS',

    SET_MY_INVOIS_FIELD: 'SET_MY_INVOIS_FIELD',
    SET_MY_INVOIS_ADDRESS_FIELD: 'SET_MY_INVOIS_ADDRESS_FIELD',
    RESET_MY_INVOIS_ADDRESS_FIELDS: 'RESET_MY_INVOIS_ADDRESS_FIELDS',

    create: request => ({
        type: actions.COMPANY_CREATE_REQUEST,
        request,
    }),
    readCompany: data => ({
        type: actions.READ_COMPANY_REQUEST,
        data,
    }),
    readMyInvoisReady: () => ({
        type: actions.READ_MY_INVOIS_READY_REQUEST,
    }),
    resetPrevIsMyInvoisReady: () => ({
        type: actions.RESET_PREV_IS_MY_INVOIS_READY,
    }),
    setPrevAndCurrentIsMyInvoisReady: (isMyInvoisReady, prevIsMyInvoisReady) => ({
        type: actions.SET_PREV_AND_CURRENT_IS_MY_INVOIS_READY,
        isMyInvoisReady,
        prevIsMyInvoisReady,
    }),
    readCompanies: () => ({
        type: actions.READ_COMPANY_LIST_REQUEST,
    }),
    // put request
    updateCompany: request => ({
        type: actions.UPDATE_COMPANY_REQUEST,
        request,
    }),
    // patch request
    patchCompanyMsic: request => ({
        type: actions.PATCH_MSIC_CODE_REQUEST,
        request,
    }),
    changeCompany: (request, reset = false) => ({
        type: actions.CHANGE_COMPANY,
        request,
        reset,
    }),
    changeCopyBillingAddress: copyBillingAddress => ({
        type: actions.CHANGE_COPY_BILLING_ADDRESS,
        copyBillingAddress,
    }),
    resetData: subdomain => ({
        type: actions.COMPANY_RESET_REQUEST,
        subdomain,
    }),
    setAllCompanyAddresses: addresses => ({
        type: actions.SET_ALL_COMPANY_ADDRESSES,
        addresses,
    }),
    addCompanyAddress: addresses => ({
        type: actions.ADD_COMPANY_ADDRESS,
        addresses,
    }),
    deleteCompanyAddress: key => ({
        type: actions.DELETE_COMPANY_ADDRESS,
        key,
    }),
    setMyInvoisField: (key, isMyInvoisFieldValid) => ({
        type: actions.SET_MY_INVOIS_FIELD,
        key,
        isMyInvoisFieldValid,
    }),
    setMyInvoisAddressField: (key, value) => ({
        type: actions.SET_MY_INVOIS_ADDRESS_FIELD,
        key,
        value,
    }),
    // supply 'values' if you want to reset the fields with the given values
    resetMyInvoisAddressFields: (hasDefaultAddress = false, values = {}) => ({
        type: actions.RESET_MY_INVOIS_ADDRESS_FIELDS,
        hasDefaultAddress, // will be true if change from no default billing address to has default billing address
        values,
    }),
};
export default actions;
